module.exports = __webpack_public_path__ + "img/202209077076.bac6a9d6.png";